import { NPAPOPUP, NPAPOPUP_SUCCESS,NPAPOPUP_FAIL } from "./actiontype";

const initialState={
    loading:false,
    popupList:[],
    postingResult:{},

}
const NpaPopupReducer = (state=initialState,action)=>{
    if (!action)
     return state;
    switch (action.type){
        case NPAPOPUP:{
            state= {...state,payload:action.payload,loading:true};
            break;
        }
            
        case NPAPOPUP_SUCCESS:
            {
            state={...state,popupList:action.payload,loading:false};
            break;
        }
        case NPAPOPUP_FAIL:
            {
            state={...state,popupList: [],loading:false};
            break;
        }
        default:{
            state= {...state};  
            break;  
        }
             
    }
    return state;
}
export default NpaPopupReducer;